import { IoClose } from "react-icons/io5";
import { useEffect } from "react";
// import {useStyletron} from 'baseui';
// import { FormControl } from "baseui/form-control";
import { useNavigate, Link } from 'react-router-dom';
import { Analytics,Gtag,FacebookPixel,Linetag } from '../compornents/Analytics';
// import axios from 'axios';
import Modal from 'react-modal';
import React from 'react';
import { BAG_FIRST } from '../bagFirst';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: '50%',
    bottom: '50%',
    marginRight: '-90%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    border: '1px solid rgb(204, 204, 204)',
    background: 'rgb(255, 255, 255)',
    overflow: 'auto',
    borderRadius: '4px',
    outline: 'none',
    padding: '0',
    overflowY: 'scroll',
    height: '90vh',
  },
};

export const Top = () => {
  const navigate = useNavigate();

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const start = () => {
    navigate("/register/step1");
  }

  const login = () => {
    navigate("/login");
  }

  useEffect(() => {
    // ログイン済み（secを保持）なら入口画面を出さずホームへ。
    // PWA(ホーム画面アプリ)は起動のたびに "/" を開くため、ここで判定しないと毎回ログインを求める見え方になる（2026-08-23）。
    // secが失効していれば Home 側の E999 処理でログイン画面へ戻る。
    try {
      if (localStorage.getItem('sec')) { navigate('/home', { replace: true }); return; }
    } catch (e) { /* noop */ }
    // console.log('Top view effect triggered');
    Gtag('view_top');
    Linetag('GenerateLead');
    FacebookPixel('ViewContent');
  }, []);

  // 「ランドリーパック Nowとは？」のモーダル（2案で共通）
  const aboutModal = (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="scrolly modal rounded p-3">
          <div className="">
            <div className="text-right">
              <Link onClick={closeModal} className="text-white">
                <IoClose className="h4 text-gray-dark" />
              </Link>
            </div>
          </div>
          <div className="p-1">
            <div className="mb-4">
              <div className="h4 text-center">LAUNDRY PACK Nowとは？</div>
              <div className="text-center">(ランドリーパック Now)</div>
            </div>
            <div className="mb-4">
              <img src="./img/delivery2.png" alt="DeliveryImage" className="ItemImage" />
            </div>
            <div className="mb-3">
              LAUNDRY PACK Nowは、創業30年超え、5万世帯以上の実績を誇る元祖宅配クリーニング店が運営する洋服のクリーニングサービスです。
            </div>
            <div className="mb-3">
              スマホから注文するだけで、配達パートナーがご自宅にお伺いし<strong>ご依頼品のお預かり〜お届けまで</strong>すべてを代行します。
            </div>
            {BAG_FIRST && (
              <div className="mb-3">
                はじめてのご注文では、<strong>まず専用バッグを無料でお届け</strong>します。届いたら依頼品を入れて、アプリから集荷をご依頼ください。
              </div>
            )}
            <div className="mb-4">
              自宅にいながらスマホ1つで “簡単クリーニング体験” ぜひお試しください！
            </div>
            <div className="mb-1">
              <img src="./img/chirashi.png" alt="ChirashiImage" className="ItemImage" />
            </div>
            <div className="">
              {BAG_FIRST ? (
                <small>※コース料金のほかにUber配達手数料が加算されます（初回は無料）。</small>
              ) : (
                <small>※990円にUber配達手数料が加算されます。</small>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );

  // ---- 従来デザイン（写真全面）。REACT_APP_BAG_FIRST 未設定時はこちら＝現行本番と同一 ----
  if (!BAG_FIRST) {
    return (
      <div className="Register">
        <Analytics title="おうちに居ながらお手軽クリーニング" />
        <div className="App-step0">
          <div className="row pt-4">
            <div className="offset-3 col-6">
              <div className="register-slide-label">
                初回配送料無料
              </div>
            </div>
          </div>
          <div className="App-h1 mt-3">{"自宅に居ながら\nクリーニング"}</div>
          <div><img src="./img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo"/></div>
          <div className="">{"集荷からお届けまでスマホひとつ！"}</div>
          <div className="App-h3">
            <div>
              <span><Link to="/rule" className="text-white">利用規約</Link></span>と<Link to="/privacy" className="text-white">プライバシーポリシー</Link>に<br />
              同意してお進みください
            </div>
            <div className="mb-2">
              <button className="button-next" onClick={start}>{"はじめる"}</button>
            </div>
            <div className="mb-2">
              <button className="button-next" onClick={login}>{"２回目の方はこちら"}</button>
            </div>
            <div className="">
              <Link onClick={openModal} className="text-white">ランドリーパック Nowとは？</Link>
            </div>
          </div>
        </div>
        {aboutModal}
      </div>
    );
  }

  // ---- 案B（イラスト・黄ベタ）。承認済みモックのトップ。 ----
  // 写真全面をやめ、メニューと同じタッチの家族イラストを主役にして「軽い・気軽」を出す。
  // 「初回配送料無料」→「初回おためし」: 改定後は配送料ではなく990円のコース自体が入口になるため。
  return (
    <div className="Register">
      <Analytics title="おうちに居ながらお手軽クリーニング" />
      <div className="top-b">
        <div className="top-b_body">
          <div className="text-center">
            <span className="register-slide-label top-b_label">初回おためし</span>
          </div>
          <div className="App-h1 top-b_h1 mt-3">
            {/* h1sub は display:block なので、ここで改行文字を足すと空行が1つ余分に入る */}
            <span className="top-b_h1sub">自宅・職場に居ながら</span>クリーニング
          </div>
          <div className="top-b_h2">{"集荷からお届けまでスマホひとつ！"}</div>
          <div><img src="./img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo"/></div>
          <img src="./img/2-8.png" alt="ご家族のイラスト" className="top-b_hero" />

          <div className="top-b_footer">
            {/* LPの訴求(専用バッグ無料)をトップでも引き継ぐ。LPで決めた方がここで迷わないようにする。
                価格は担当店で異なる(白光舎は初回3点1,980円・他は990円)ため、この時点では出さない。 */}
            {BAG_FIRST && (
              <div className="top-b_offer">まずは<strong>専用バッグを無料</strong>でお届けします</div>
            )}
            <button className="button-next top-b_cta" onClick={start}>
              {BAG_FIRST ? "無料で専用バッグを受け取る" : "はじめる"}
            </button>
            {/* 同意文はCTAの下へ。押す前の心理的ハードルを下げる（同意の明示自体は維持） */}
            <div className="top-b_legal">
              <Link to="/rule" className="top-b_link">利用規約</Link>と<Link to="/privacy" className="top-b_link">プライバシーポリシー</Link>に<br />
              同意してお進みください
            </div>
            {/* ログイン導線は必須。主役(CTA)と競合しないよう、下部の控えめな見た目で残す */}
            <button className="top-b_sub" onClick={login}>{"２回目の方はこちら"}</button>
            <div className="mt-2">
              <Link onClick={openModal} className="top-b_link">ランドリーパック Nowとは？</Link>
            </div>
          </div>
        </div>
      </div>
      {aboutModal}
    </div>
  );
}
